import styled from 'styled-components';
import { Skeleton } from '@mui/material';

import { FirstColumn, RecordRow, SecondColumn } from 'containers/CompanySettings/MasterServiceAgreement/styles';

export const SettingsSection = styled.section`
  margin-top: ${({ theme }) => theme.spacing(1.25)};
`;

// Not baseline-aligned: the loading skeleton has no baseline, so the label would sit at its bottom edge
export const FieldRow = styled(RecordRow)`
  align-items: flex-start;
`;

export const FieldColumn = styled(SecondColumn)`
  flex: 1;
  min-width: 0;
`;

export const PreferenceField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const LabelColumn = styled(FirstColumn)`
  padding-top: 3px;
`;

export const LoadError = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const FieldSkeleton = styled(Skeleton)`
  width: 100%;
  height: 40px;
`;
